import dynamic from "next/dynamic";
import ZendeskSideBySideFormConfig from "./zendesk-side-by-side-form-config";
import ZendeskSideBySideFormAdvancedConfig from "./zendesk-side-by-side-form-advanced-config";
const ZendeskSideBySideFormComponent = dynamic(()=>import("./zendesk-side-by-side-form-component"));
export default {
    ZendeskSideBySideFormComponent,
    ZendeskSideBySideFormConfig,
    ZendeskSideBySideFormAdvancedConfig
};
